import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
/**
 * Create a named context provider with its value provided by a hook
 * @param Context React Context object
 * @param useHook the hook to provide the context value
 * @returns a Component with wraps a context provider
 */
export function createNamedProvider(Context, useHook, propsAreEqual) {
    const Provider = memo(props => _jsx(Context.Provider, { value: useHook(props), children: props.children }), propsAreEqual);
    Provider.displayName = `${Context.displayName}.ProviderWrapper`;
    return Provider;
}
//# sourceMappingURL=createNamedProvider.js.map